var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgLinkedIn = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M3.45860771,8.8301028 L7.0023946,8.8301028 L7.0023946,21.180654 L3.45860771,21.180654 L3.45860771,8.8301028 Z M5.14016933,7.28526525 L5.11451296,7.28526525 C3.83169418,7.28526525 3,6.34113319 3,5.14554302 C3,3.92550554 3.85628154,3 5.16475669,3 C6.47216283,3 7.2760626,3.92317722 7.30171898,5.14205055 C7.30171898,6.33764072 6.47216283,7.28526525 5.14016933,7.28526525 Z M21.1818182,21.1818182 L17.1633884,21.1818182 L17.1633884,14.7894271 C17.1633884,13.1165322 16.5348071,11.9756575 15.1525699,11.9756575 C14.0953134,11.9756575 13.5073548,12.7451658 13.2336868,13.4890627 C13.1310613,13.7544907 13.1470966,14.1258571 13.1470966,14.4983876 L13.1470966,21.1818182 L9.16608227,21.1818182 C9.16608227,21.1818182 9.21739502,9.85921838 9.16608227,8.8301028 L13.1470966,8.8301028 L13.1470966,10.7684257 C13.38228,9.92091875 14.6544086,8.71135869 16.6844693,8.71135869 C19.2030702,8.71135869 21.1818182,10.4890278 21.1818182,14.3132865 L21.1818182,21.1818182 Z"
  }));
};
export default SvgLinkedIn;